<template>
  <div class="left_block search">
    <p class="header">
      <span class="left">Результаты поиска</span>
    </p>

    <div class="search-content">
      <CategoryItem
        v-for="(course, i) in searchResultsList"
        :key="String(course.data.id) + i"
        :course-info="course.data"
        @click="openCourseInfo"
      />

      <KBItem v-for="(file, i) in searchKBResultsList" :key="String(file.data.id) + i" :KBInfo="file.data" />
    </div>
    <div class="search-pagination">
      <span>{{
        search.page * 15 -
        14 +
        '-' +
        (search.page * 15 > searchTotal ? searchTotal : search.page * 15) +
        ' / ' +
        searchTotal
      }}</span>
      <div class="search-pagination__buttons">
        <button :disabled="search.page === 1" @click="changePage('minus')">
          <i class="mdi mdi-chevron-left mdi-24px"></i>
        </button>
        <button :disabled="search.page * 15 >= searchTotal" @click="changePage('plus')">
          <i class="mdi mdi-chevron-right mdi-24px"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import KBItem from '@/components/search/KBItem'
import CategoryItem from '@/components/home/CategoryItem'
import { toastDanger } from '@/lib/toastCfg'

export default {
  components: {
    CategoryItem,
    KBItem
  },
  data() {
    return {
      search: {
        page: 1
      }
    }
  },
  mounted() {
    this.loadData()
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === this.$route.name) {
      next()
      this.loadData()
    }
  },
  computed: {
    isAuth() {
      return this.$store.state.auth.auth
    },
    searchTotal() {
      return this.$store.state.search.searchTotal
    },
    searchResultsList() {
      return this.$store.state.search.searchResultsList
    },
    searchKBResultsList() {
      return this.$store.state.search.searchKBResultsList
    }
  },
  methods: {
    changePage(val) {
      if (val === 'plus') {
        this.search.page += 1
      } else {
        this.search.page -= 1
      }
      this.loadData()
    },
    loadData() {
      if (!this.$route.query.text) {
        return
      }
      this.$axios2
        .get('search?text=' + this.$route.query.text + '&page=' + this.search.page)
        .then((resp) => {
          let coursesData = resp.data.data.filter((el) => el.type === 'COURSE')
          let kbData = resp.data.data.filter((el) => el.type === 'KB')
          this.$store.commit('setSearchResultsList', {
            coursesData: coursesData,
            total: resp.data.total,
            kbData: kbData
          })
          if (!resp.data.data.length) {
            this.$buefy.toast.open(toastDanger('Ничего не найдено'))
          }
        })
        .catch(this.$errorToast)
    },
    openCourseInfo(courseId) {
      this.$router.push('/course-info/' + courseId)
    }
  }
}
</script>
